// Copyright 2024 Sorama B.V.

import { inject } from "aurelia-framework";
import { MeasurementChannelSelection } from "datatypes/MeasurementChannelSelection";

@inject()
export class ChannelSelectionScope {
    private selectedChannelsForMeasurementIds: MeasurementChannelSelection[] = [];
    private globalChannelSelectionForMeasurementIds: MeasurementChannelSelection[] = [];
    private isSelectionGlobal = false;

    constructor() {}

    // Getter for channel selection (depends on isSelectionGlobal)
    get channelSelection(): MeasurementChannelSelection[] {
        return this.isSelectionGlobal
            ? this.globalChannelSelectionForMeasurementIds
            : this.selectedChannelsForMeasurementIds;
    }

    // Setter for channel selection (updates the correct array based on isSelectionGlobal)
    set channelSelection(value: MeasurementChannelSelection[]) {
        if (this.isSelectionGlobal) {
            this.globalChannelSelectionForMeasurementIds = value;
        } else {
            this.selectedChannelsForMeasurementIds = value;
        }
    }

    // Optionally add methods to manage global/local selections separately
    setGlobalChannelSelection(selection: MeasurementChannelSelection[]) {
        this.globalChannelSelectionForMeasurementIds = selection;
    }

    setSelectedChannelSelection(selection: MeasurementChannelSelection[]) {
        this.selectedChannelsForMeasurementIds = selection;
    }
}
